import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Col,
    Container,
    Row,
    Spinner,
    Stack,
    Table,
    Form,
    Modal,
    FormGroup,
    FormLabel,
    Badge,
} from "react-bootstrap";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader,
} from "react-bs-datatable";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { ROUTES } from "../../constants/webRouting";
import DateRangePicker from "rsuite/DateRangePicker";
// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/DateRangePicker/styles/index.css";
import ".././../assets/css/ListComponentsTable.css";
import { formatDate, formatDateForView, getUserDetails } from "../../utils/helper";
import InfoPill from "../InfoPill";
import * as Constant from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions"; 
import PubSub from "pubsub-js";
import UserMultiSelect from "../common/UserMultiSelect";
import moment from "moment";//Added by shahir hussain 31-12-2025

const OrderList = () => {
    const userInfo = getUserDetails();
    const navigate = useNavigate();
    const [body, setBody] = useState();
    const [dateRange, setDateRange] = React.useState([
        // new Date(),
        // new Date()
    ]);

    const [filterData, setFilterData] = useState({ order_status: "Order Work in Progress" });   //Imran Khan 06-01-2026 set default filter for order status
    const [products, setLeadsValues] = useState([]);
    const [assignUsers, setAssignUsers] = useState([]);
    const [accounts, setAccounts] = useState([]);
    //Added by shahir hussain for transfer owner 
      const [changeOwnerModal, setChangeOwnerModal] = useState(false);
      const [refreshRecords, setRefreshRecords] = useState(false);
      const [ownerLeads, setOwnerLeads] = useState([]);
      const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
      const [fromUser, setFromUser] = useState({});
      const [toUser, setToUser] = useState({});
      const tableRef = useRef(null);
      const [users, setUsers] = useState([]);
      const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
      const [leadCities, setLeadCities] = useState([]);
      const [selectedToUsers, setSelectedToUsers] = useState([]);
    //Ended by shahir hussian 31-12-2025

    useEffect(() => {
        const filter = { ...filterData };
        delete filter.owner_name;
        delete filter.product_name;
        delete filter.lead_name;
        filter.owner_ids = filter?.owner_ids?.filter((item) => (item.value))?.map((item) => item.value);
        filter.account_id = filter?.accounts?.filter((item) => (item.value))?.map((item) => item.value);
        delete filter.accounts;
        if (Array.isArray(dateRange) && dateRange.length > 0) filter.date_range = { filed: 'createddate', createddate: { from: formatDate(dateRange?.at(0) || null), to: formatDate(dateRange?.at(1) || null), } };
        fetchOrders(filter);
    }, [dateRange, filterData]);

    async function init() {
        if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
        })) {
            const resultedUsers = await fuziElevatorsApi.fetchUsers();
            resultedUsers &&
                Array.isArray(resultedUsers) &&
                setAssignUsers(
                    resultedUsers.map((user) => ({
                        value: user.id,
                        label: user.username,
                    }))
                );
        }
        const resultedAccounts = await fuziElevatorsApi.fetchAccounts();
        resultedAccounts && Array.isArray(resultedAccounts) && setAccounts(resultedAccounts);
    }

    async function fetchOrders(filters) {
        const result = await fuziElevatorsApi.fetchOrders(filters);

        if (result) {
            setBody(result);
            (Array.isArray(result) && (filters?.offer_id === undefined || filters?.offer_id === null)) &&
                setLeadsValues(
                    result?.map((fetchedContact) => ({
                        id: fetchedContact?.offer_id,
                        name: `${fetchedContact?.offer_name_label || ""}`,
                    }))
                );
        } else {
            setBody([]);
        }

    }
    useEffect(() => {
        init();
        // fetchOrders();
    }, []);

    // Create table headers consisting of 4 columns.
    // Randomize data of the table columns.
    // Note that the fields are all using the `prop` field of the headers.
    const header = [];
    if (!isMobile) {
        header.push(
            {
                title: "Offer",
                prop: "offer_name_label",
                isFilterable: true,
                cell: (row) => (
                    <Link to={`${ROUTES.ORDER.LIST}/${row.id}`} state={row}>
                        {row.offer_name_label}
                    </Link>
                ),
                isSortable: true,
            },
            //formatDateForView added by shahir hussain 27-08-2025
            {
                title: "Order Date",
                prop: "order_date",
                isFilterable: true,
                cell: (row) => (row?.order_date ? formatDateForView(row.order_date) : ""),
                isSortable: true,
            },

            {
                title: "Site Address",
                prop: "site_address",
                isFilterable: true,
            },

            {
                title: "City",
                prop: "city",
                isFilterable: true,
            },

            {
                title: "Sector",
                prop: "sector",
                isFilterable: true,
            },

            {
                title: "Make",
                prop: "accounts",
                // cell: (row) => (

                //     row.accounts?.map((item) =>
                //         item?.value && <>
                //             <Link to={`${ROUTES.ACCOUNT.LIST}/${item.value}`} >
                //                 {item.label}
                //             </Link>
                //             <br />
                //         </>

                //     )),
                cell: (row) => {
                    if (!row.account_id || !Array.isArray(row.account_id)) return null;

                    const matchedAccounts = accounts.filter(acc =>
                        row.account_id.includes(acc.id)
                    );

                    return (
                        <>
                            {matchedAccounts.map((acc, index) => (
                                <span key={acc.id}>
                                    <Link to={`${ROUTES.ACCOUNT.LIST}/${acc.id}`}>
                                        {acc.name}
                                    </Link>
                                    {index < matchedAccounts.length - 1 && ", "}
                                </span>
                            ))}
                        </>
                    );
                },
                isFilterable: true,
            },

            {
                title: "Lead Type",
                prop: "leadtype",
                isFilterable: true,
                isSortable: false,
            },

            {
                title: "Product",
                prop: "product_name",
                cell: (row) => (
                    <Link to={`${ROUTES.PRODUCT.LIST}/${row.product_id}`} >
                        {row.product_name}
                    </Link>
                ),
                isFilterable: true,
            },

            {
                title: "Order Status",
                prop: "order_status",
                isFilterable: true,
                isSortable: true,
                alignment: { horizontal: "center" },
                cell: (row) => (
                    <span
                        className="badge rounded-pill w-100"
                        style={getStatusClass(row.order_status)}
                    >
                        {row.order_status}
                    </span>
                ),
            },
        );
        [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
        }) && (
                header.push(
                    {
                        title: "Order Amount",
                        prop: "order_amount",
                        isFilterable: true
                    },

                    {
                        title: "Paid Amount",
                        prop: "paid_amount",
                        isFilterable: true
                    },

                    {
                        title: "Due Amount",
                        prop: "due_amount",
                        isFilterable: true
                    },
                    // {
                    //     title: "Assign User",
                    //     prop: "owner_name",
                    //     isFilterable: true,
                    //     cell: (row) => (
                    //         <Link to={ROUTES.USER + row.owner_id} state={row}>
                    //             {row.owner_name}
                    //         </Link>
                    //     ),
                    // }
                )
            );
    } else {
        //for mobile device
        header.push({
            title: "Info",
            prop: "offer_name",
            isFilterable: true,
            isSortable: true,
            cell: (row) => (
                <div className="mobilecard">
                    <Link
                        to={`${ROUTES.ORDER.LIST}/${row.id}`}
                        state={row}
                        style={{ width: "100%" }}
                    >
                        {row.offer_name}
                    </Link>

                    <span>
                        <i className="fa-solid fa-phone"></i> {row.phone}
                    </span>
                    <span style={{ width: "80%" }}>
                        <i className="fa-solid fa-envelope"></i> {row.email}
                    </span>
                </div>
            ),
        });
    }

    const labels = {
        beforeSelect: " ",
    };

    const createOrder = () => {
        navigate(ROUTES.ORDER.CREATE);
    };

    const handleChange = (e) => {//For Filteration Work.
        setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
    };

    //For Searching Filteration.

    const handleSearch = async (e) => {
        // console.log("Leaad", filterData);
        const result = await fuziElevatorsApi.fetchAllFilterRecordsOrder(filterData);
        // console.log("result", result);
        setBody([...result]);
    };

    //For Searching Filteration Clear.
    const handleClear = () => {
        setFilterData({});
        fetchOrders();
        // fetchLeads();
        // handleSearch();
    };

    const getStatusClass = (status) => {
        const OFFER_STATUS_VALUES = [
            //Updated by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket
            // 1
            {
                label: "Enquiry Pending",
                sortorder: 1,
                is_converted: false,
                is_lost: false,
                css: { color: "black", backgroundColor: "#C7DCE3" }
            },

            // 2
            {
                label: "Enquiry Lost",
                sortorder: 2,
                is_converted: false,
                is_lost: true,
                css: { backgroundColor: "#F93827" }
            },

            // 3
            {
                label: "Site Visit Pending",
                sortorder: 3,
                is_converted: false,
                is_lost: false,
                css: { backgroundColor: "#8B4513" }
            },

            // 4
            {
                label: "Site Visit Complete",
                sortorder: 4,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#32CD32" }
            },

            // 5
            {
                label: "Site Visit Lost",
                sortorder: 5,
                is_converted: false,
                is_lost: true,
                css: { backgroundColor: "#F93827" }
            },

            // 6
            {
                label: "Offer Pending",
                sortorder: 6,
                is_converted: false,
                is_lost: false,
                css: { backgroundColor: "#FFD700" }
            },

            // 7
            {
                label: "Offer Submitted",
                sortorder: 7,
                is_converted: false,
                is_lost: false,
                css: { backgroundColor: "#FF9D23" }
            },

            // 8
            {
                label: "Offer Lost",
                sortorder: 8,
                is_converted: false,
                is_lost: true,
                css: { backgroundColor: "#7d0e04ff" }
            },

            // 9
            {
                label: "Order Received",
                sortorder: 9,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#9ef49eff" }
            },

            // 10
            {
                label: "Order Lost",
                sortorder: 10,
                is_converted: false,
                is_lost: true,
                css: { backgroundColor: "#3833ceff" }
            },

            // 11
            {
                label: "Order Work in Progress",
                sortorder: 11,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#1E90FF" }
            },

            // 12
            {
                label: "Order Work Complete",
                sortorder: 12,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#eb0c61ff" }
            },

            // 13
            {
                label: "Warranty Running",
                sortorder: 13,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#7851A9" }
            },

            // 14
            {
                label: "Warranty Lost",
                sortorder: 14,
                is_converted: false,
                is_lost: true,
                css: { backgroundColor: "#476038ff" }
            },

            // 15
            {
                label: "AMC Running",
                sortorder: 15,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#008080" }
            },

            // 16
            {
                label: "AMC Lost",
                sortorder: 16,
                is_converted: false,
                is_lost: true,
                css: { backgroundColor: "#f71702ff" }
            },

            // 17
            {
                label: "AMC Direct Order",
                sortorder: 17,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#87e2deff" }
            },

            // 18
            {
                label: "One Time",
                sortorder: 18,
                is_converted: true,
                is_lost: false,
                css: { backgroundColor: "#9b3131ff" }
            }
            ];
            //ended by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket

        const statusObj = OFFER_STATUS_VALUES.find(
            (value) => value.label === status
        );
        return statusObj ? statusObj.css : {};
    };

    const customFilter = (rows, filters) => {
        return rows.filter((row) => {
            return Object.keys(filters).every((column) => {
                const filterValue = filters[column]?.toLowerCase() || "";
                if (!filterValue) return true; // filter empty hai to row include karo

                const rowValue = row[column]?.toString().toLowerCase() || "";
                return rowValue.includes(filterValue); // substring + case-insensitive
            });
        });
    };

    //Added by shahir hussain for change user 31-12-2025
    const handelCheckBox = (e) => {
        [...(tableRef.current.querySelectorAll(`input[name='leads']`))].forEach((elm) => {
        elm.checked = e.target.checked;
        })
    }

      //Added by shahir hussain for change user 31-12-2025
      useEffect(() => {
        (async () => {
          try {
            const fetchUsers = await fuziElevatorsApi.fetchUsersForListPage();
            // const fetchContacts = await fuziElevatorsApi.fetchContacts();//For Ref Partner Filter According to Client Requiment.
            // if (Array.isArray(fetchContacts)) {
            //   setContacts(fetchContacts?.map(({ id, firstname, lastname, phone }) => ({ value: id, label: `${firstname} - ${lastname} - ${phone}` })))//Set Contacts
            // } else {
            //   setContacts([]);
            // }
            if (Array.isArray(fetchUsers)) {
              setUsers(fetchUsers?.map(({ id, username, userrole }) => ({ value: id, label: `${username} - ${userrole}` })));
            } else {
              setUsers([]);
            }
          } catch (error) {
            console.error("Failed to load users/contacts:", error);
            setUsers([]);
            // setContacts([]);
          }
    
        })();
      }, []);

    //Added by shahir hussain for change user 31-12-2025
      useEffect(() => {
        (async () => {
          if (fromUser && fromUser?.value) {
            setSpinnerForChangeOwner(true);
            const leads = await fuziElevatorsApi.getOrderByStaffId(fromUser?.value);
            if (leads.success) {
    
              setOwnerLeads(leads?.data);
              setOwnerLeadsHeader([
                {
                  title: <Form.Check
                    type={"checkbox"}
                    label="Select All"
                    name="all_leads"
                    onChange={handelCheckBox}
                  />,
                  prop: "id",
                  isFilterable: true,
                  cell: (row) => (
                    <Form.Check
                      type={"checkbox"}
                      id={`${row.id}`}
                      name="leads"
                    />
                  ),
                },
                {
                  title: "Offer",
                  prop: "offer_name_label",
                  isFilterable: true,
                  cell: (row) => (
                    <Link to={"/orders/" + row.id} state={row}>
                      {row.offer_name_label}
                    </Link>
                  ),
                },
                {
                  title: "Order Status",
                  prop: "order_status",
                  isFilterable: true, isSortable: true,
                //   cell: (row) => {
                //     return (
                //       <Badge bg={getStatusClass(row.order_status)} style={{ display: "block", paddingBottom: "5px" }}>
                //         {row.order_status}
                //       </Badge>
                //     );
    
                //   },
                },
                {
                  title: "Created Date", prop: "createddate", isSortable: true, isFilterable: true, cell: (row) => (
                    <span>
                      {moment(row.createddate).format('DD-MM-yyyy')}
                    </span>
                  )
                },
                {
                  title: "Assigned",
                  prop: "ownername",
                  isFilterable: true,
                  isSortable: true,
                  cell: (row) => {
                    const titleAbbreviations = {
                      "Sales Admin": "S. S.",
                      "Installation Admin": "I. A.",
                      "Accounts": "ACCOUNTS",
                      "Accounts Admin": "A. A.",
                      "Installation Engineer": "I. E.",
                      "Installation Supervisor": "I. S.",
                      "Business Development Executive": "B. D. E.",
                      "Customer Relationship Executive": "C. R. E.",
                      "Office": "OFFICE",
                      "Office Coordinator": "O. C.",
                      "Office Executive": "O. E.",
                      "Service Admin": "S. R.",
                      "SUPER_ADMIN": "SUPER_ADMIN" // If no abbreviation is needed
                    };
    
    
                    const ownerNames = row.ownername ? row.ownername.split(', ') : [];
                    const ownerIds = row.ownerid ? row.ownerid : [];
    
                    const shortenTitle = (name) => {
                      const [fullName, title] = name.split(' - ');
                      const shortTitle = titleAbbreviations[title.trim()] || title; // Use abbreviation if available
                      return `${fullName} - ${shortTitle}`;
                    };
    
                    const links = ownerNames.map((name, index) => (
                      <Link
                        key={index} // Use index as key if ownerIds[index] is not reliable
                        to={`/users/${ownerIds[index]}`}
                        state={row}
                        className="align-items-center justify-content-start"
                      >
                        {shortenTitle(name)}<br />
                      </Link>
                    ));
                    return <span>{links}</span>;
                  },
                },
              ]);
            }
            else {
              setOwnerLeads([]);
              setOwnerLeadsHeader([]);
            }
            setSpinnerForChangeOwner(false);
          } else {
            setOwnerLeads([]);
            setOwnerLeadsHeader([]);
          }
        })();
      }, [fromUser])

    //Added by shahir hussain for change user 31-12-2025
    const handelChangeOwnerModalClose = () => {
        setChangeOwnerModal(false);
        setRefreshRecords(!(refreshRecords));
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
        setFromUser({});
        setToUser({});
        setSelectedToUsers([])
    }

    //Added by shahir hussain for change user 31-12-2025
    const ChangeOwner = (e) => {
    e.preventDefault();
    let leads = [...(tableRef?.current?.querySelectorAll(`input[name='leads']`))];
    leads = leads?.filter((elm) => (elm.checked));
    leads = leads?.map((elm) => (elm.id));

    const toUsers = selectedToUsers.map(u => u.value);
    (async () => {
        const result = await fuziElevatorsApi.ChangeOrderOwner({ fromUser: fromUser.value, toUser: toUsers, leads });
        if (result.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Transfer Owner', message: 'Owner Transfer successfully' });
        setSelectedToUsers([]);
        handelChangeOwnerModalClose();
        } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Transfer Owner Error', message: 'Some error occurred' });
        }
    })();
    }

    const handelFromUserSelect = (e) => {
        if (e) {
        setFromUser(e);
        }
        else {
        setFromUser(e);
        }
    }

    return (
        <Container fluid>
            <DatatableWrapper
                body={body && Array.isArray(body) ? body : []}
                headers={header}
                paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 50,
                        options: [5, 10, 15, 20, 30, 50]
                    },
                }}
                sortProps={{ initialState: { prop: 'order_date', order: "desc" } }}
                filterFunction={customFilter}
            >
                <Row className="">
                    {/* <p style={{ fontSize: "22px", display: "flex", justifyContent: "center", fontWeight: "bold" }}>Search Filter</p> */}
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicState"
                            >
                                Offers
                            </Form.Label>

                            <Select
                                placeholder="Select your Offer"
                                classNamePrefix="react-select"
                                className="z-3"
                                options={products?.map((product) => ({
                                    value: product?.id,
                                    label: product?.name,
                                }))}
                                onChange={(e) => {
                                    handleChange({
                                        target: { name: "offer_id", value: e.value },
                                    });
                                    handleChange({
                                        target: { name: "lead_name", value: e.label },
                                    });
                                }}
                                value={
                                    filterData?.offer_id
                                        ? {
                                            value: filterData?.offer_id,
                                            label: filterData?.lead_name,
                                        }
                                        : ""
                                }
                            ></Select>
                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col lg={3}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicStatus"
                            >
                                Order Status
                            </Form.Label>
                            <Form.Select
                                name="order_status"
                                value={filterData?.order_status || ""}
                                onChange={handleChange}
                            >
                                <option value="">---select status---</option>
                                {Constant.ORDER_STATUS_VALUES?.map((status, index) => (
                                    <option value={status.label || ""} key={index}>
                                        {status.label || ""}
                                    </option>
                                ))}
                            </Form.Select>

                            <Form.Control.Feedback type="invalid">

                            </Form.Control.Feedback>

                        </Form.Group>
                    </Col>
                    <Col lg={2}>
                        <Form.Group className="mt-2" controlId="formBasicCourses">
                            <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicLeadManagerId"
                            >
                                Assigned User
                            </Form.Label>
                            <Select
                                // isClearable
                                className="z-3"
                                classNamePrefix="react-select"
                                isMulti
                                name="owner_ids"
                                onChange={(e) => {
                                    handleChange({
                                        target: { name: "owner_ids", value: e },
                                    });
                                }}
                                value={
                                    filterData?.owner_ids?.filter((item) => (item.value))
                                }
                                options={assignUsers}
                            />
                        </Form.Group>
                    </Col>

                </Row>
                <Row className="align-items-end">
                    <Col>
                        <Filter
                            classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }}
                        />
                    </Col>
                    <Col md={1}>
                        <PaginationOptions labels={labels} />
                    </Col>

                    <Col>
                        <DateRangePicker
                            value={dateRange}
                            onChange={(e) => {
                                setDateRange(e);
                            }}
                            // format="dd/mm/yyyy"
                            character=" – "
                        />
                    </Col>
                    <Col className="py-1">
                        <BrowserView>
                            <div className="d-flex py-1 px-2 ">
                                <InfoPill
                                    left="Total"
                                    right={body?.length}
                                    rightClasses="bg-custom text-white border-white fw-bold"
                                    leftClasses="bg-white text-danger fw-bold "
                                />
                            </div>
                        </BrowserView>
                    </Col>
                    <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                    >
                        <Stack direction="horizontal" gap={2}>
                            {/* <Button variant="success" onClick={handleSearch}><i class="fas fa-search"></i></Button> */}
                            {userInfo?.userrole === "SUPER_ADMIN" && (
                            <Button onClick={() => (setChangeOwnerModal(true))} className="btn-sm" >Transfer Owner</Button>
                            )
                            }
                            <Button variant="secondary" onClick={handleClear}><i class="fa fa-refresh" aria-hidden="true"></i></Button>
                            {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_ORDER].some(permission => {
                                return userInfo?.permissions?.map(p => p.name).includes(permission);
                            }) && (
                                    <Button
                                        size="sm"
                                        className="btn-create"
                                        onClick={() => createOrder(true)}
                                    >
                                        New Order
                                    </Button>
                                )
                            }
                        </Stack>
                    </Col>
                </Row>

                {/* <Table striped className="shadow rounded sm my-4" responsive={true}>
                    <TableHeader classes={{ th: "bg-custom text-white" }} />
                    {body && Array.isArray(body) ? (
                        <TableBody />
                    ) : (
                        <tbody className="">
                            <tr>
                                <td colSpan={100} align="center">
                                    <div>
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </Table> */}

                <div className="table-scroll my-3">
                    <Table striped className="shadow rounded sm my-4">
                        <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
                        {
                            (body && Array.isArray(body)) ?
                                <TableBody />
                                :
                                <tbody className="">
                                    <tr>
                                        <td colSpan={100} align="center">
                                            <div>
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                        }
                    </Table>
                </div>
                <Pagination
                    classes={{
                        buttonGroup: "btn-custom",
                        button: "bg-custom border-white",
                    }}
                />
            </DatatableWrapper>
    {/* Added this modal by shahir hussain for change user 31-12-2025 */}
      {changeOwnerModal && <Modal
        show={changeOwnerModal}
        onHide={handelChangeOwnerModalClose}
        size={"xl"}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Transfer Owner
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={ChangeOwner} >
          <Modal.Body >
            <Row className="gap-3">
              <Col lg={12} >
                <Row className="">
                  <Col lg={6}>
                    <FormGroup>
                      <FormLabel>From</FormLabel>
                      <Select
                        isClearable
                        options={users}
                        onChange={handelFromUserSelect}
                        name="fromUser"
                        required
                      >
                      </Select>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup>
                      {/* <FormLabel>To</FormLabel>
                      <Select
                        isClearable
                        options={users}
                        onChange={handelToUserSelect}
                        name="toUser"
                        required
                      >
                      </Select> */}
                      <UserMultiSelect
                        options={users}
                        value={selectedToUsers}
                        onChange={setSelectedToUsers}
                        label="To"
                      />
                    </FormGroup>
                  </Col>

                </Row>
              </Col>
              <Col lg={12} >
              </Col>
            </Row>
            {(fromUser && Object.keys(fromUser)?.length > 0) &&
              <Container style={{ height: "50vh", overflowY: "auto" }}>

                {!spinnerForChangeOwner ?
                  <DatatableWrapper
                    body={ownerLeads}
                    headers={ownerLeadsHeader}
                  >
                    <Table striped className="data-table" ref={tableRef}>
                      <TableHeader />
                      <TableBody />
                    </Table>
                  </DatatableWrapper>
                  :
                  <div className="d-flex justify-content-center align-items-center mt-5" >
                    <Spinner animation="border" variant="secondary" size="lg" />
                  </div>
                }
              </Container>
            }


          </Modal.Body>
          <Modal.Footer>
            <div className='submit'>
              <Button variant="success" type="submit" >
                Change
              </Button>
            </div>
            <Button onClick={handelChangeOwnerModalClose} variant="light">
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>}
        </Container>
    );
};

export default OrderList;
